import brickTypes from './brick-types';

const initializeJourneyBrick = (brick) => {
    //Ensure our brick always has one, single, outgoing connection used for hooking our journey up
    if(brick.isChildJourneyBrick){
        if(brick.outgoingConnections.length === 0){
            brick.addConnection();
        }
    }
};

const initializeAudienceFilterBrick = (brick) => {
    const _deregisterConnection = brick.deregisterConnection;
    
    //Proxy to original instance
    const deregisterConnectionImpl = (connection) => _deregisterConnection.call(brick, connection);
    
    const sanitizeText = text => {
        //Our tooltips are expected to contain HTML
        //we want to prevent HTML from being injected however
        //thus sanitize via the DOM api
        const span = document.createElement('span');
        span.innerText = text;
        return span.innerHTML;
    };

    const extractHtml = node => {
        //To get the outerHTML of a node, the node needs a wrapper
        const wrapper = document.createElement('div');
        wrapper.appendChild(node);
        return wrapper.innerHTML;
    };
    
    const updateConditionEndpoints = (config) => {
        const conditions = config.conditions || [];

        //Create a copy of our array to prevent modifying the original while enumerating over it
        [...brick.outgoingConnections].forEach(connection => {
            const connectionIsDeleted = !conditions.find(c => c.connectionId === connection.id);

            //Calling delete will trigger another updateConditionEndpoints cycle;
            //to prevent this we should never call connection.delete()/brick.deregisterConnection(connection)
            if(connectionIsDeleted){
                deregisterConnectionImpl(connection);
                
                //Ensure connection is properly removed from self/destination
                if(connection.destinationBrick) connection.destinationBrick.deregisterConnection(connection);
            }
        });

        //Create new connections for each condition without a connection
        //this can occur both on altering the configuration
        //or on load, when a brick did not have all endpoints connected on save
        conditions.forEach(condition => {
            const currentConnection = brick.connections.find(c => c.id === condition.connectionId);
            const { ui, id: connectionId } = currentConnection || brick.addConnection();

            condition.connectionId = connectionId;

            ui.color = condition.color;

            const contentUl = (condition.fields || []).reduce((ul, field) => {
                const li = document.createElement('li');

                li.innerText = `${field.type || ''} - ${field.value || ''}`;
                ul.appendChild(li);

                return ul;
            }, document.createElement('ul'));

            ui.tooltip = {
                title: sanitizeText(condition.name),
                content: extractHtml(contentUl)
            };
        });
    };
    
    //Overwrite with our own handler
    //this to ensure updateConditionsEndpoints gets invoked on
    //connection removal
    brick.deregisterConnection = (connection) => {
        deregisterConnectionImpl(connection);
        updateConditionEndpoints(brick.config);
    };
    
    Object.defineProperties(brick, {
        _config: {
            enumerable: false,
            configurable: false,
            writable: true,
            value: brick.config
        },
        config: {
            enumerable: true,
            get(){
                return this._config;
            },
            set(newConfig){
                this._config = newConfig;
                updateConditionEndpoints(this._config);
            }
        }
    });

    updateConditionEndpoints(brick.config);
};

export default {
    [brickTypes.journey]: initializeJourneyBrick,
    [brickTypes.audienceFilter]: initializeAudienceFilterBrick
};